import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ActionService {
    private _actionTriggered = new Subject<void>();

    /** Observable that emits when a global action (like the main FAB) is triggered */
    actionTriggered$ = this._actionTriggered.asObservable();

    /** Triggers the global action event */
    triggerAction(): void {
        this._actionTriggered.next();
    }
}
